import React, {useEffect, useState} from "react";
import {Button, Col, Divider, Form, message, Row, Space, Spin, Typography} from "antd";

import {InputFields} from "../../../../../../../components/common";

import {useAppDispatch, useAppSelector} from "../../../../../../../redux/hooks";

import {dataFields as inputFieldsInit ,dataFieldKQ} from "./config";
import {employeeService} from "api"
import Notification from "../../../../../../../components/common/notification/notification";
import {dataFieldsL, dataFieldsTC} from "../../../../EmployeeDirectory/components/LaborContract/FormAdd/config";
import {RefreshIconSVG} from "../../../../../../../assets";
import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import Icon from "../../../../../../../assets/icons";
import {field} from "../Tab1/config";
import {setEmployee} from "../../../../../../../redux/reducer/employee";
import dayjs from "dayjs";

const Tab3 = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector(
      (state) => state.employeesReducer
  );
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const [fieldStates, setFieldStates] = useState(dataFieldKQ);
  const [datas, setDatas] = useState<any>([]);

  const [value, setValue] = useState(1);
  const id = data.id
  useEffect(() => {
    if (datas && datas.ketQua !== null) {
      setValue(datas.ketQua);
      form.setFieldsValue({
        ...datas,
      });
    } else {
      setValue(1);
      // Xử lý form khi datas không tồn tại hoặc datas.ketQua là null
    }
    }, [datas]);

  useEffect(() => {
    getDetailsRecruitment(id);
    }, [id]);
  const onChange = (e: RadioChangeEvent) => {

    setDatas({...datas , ketQua : e.target.value});
  };
  const handleSubmit = async () => {
    setLoading(true);
    const values = form.getFieldsValue();

    try {
      const params = {
        ...values,
        id:data.id ,
        ketQua : value,
        idDanhMucUngVien:id,
      };
      const res = await employeeService.updateCandidateDirectoryKQ(params).then(res => {
        Notification("success", "Đã chỉnh sửa thành công ");

      });
      setLoading(false);
      closeModal();
      await getListApi({});

    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin kết quả tuyển dụng");

    }
  };

  const getDetailsRecruitment = async (id) => {

    try {
        const res = await employeeService.getCandidateDirectory(id);
        if(res.code === 200){
          setDatas(res.data);
        }else {
          form.resetFields();
        }

    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }


  };
  useEffect(() => {
    form.setFieldsValue({
      ...datas,
      ngayNhanViec: datas?.ngayNhanViec
        ? dayjs(datas.ngayNhanViec)
        : null,
    });
}, [datas]);
  const handleEdit = () => {
    setIsEditing(true);
  };
  // useEffect(() => {
  //   if (isEditing !== false){
  //     const updatedFieldTT = inputFieldsInit.map(field => {
  //       if (field.name === "fileCV") {
  //         return {
  //           ...field,
  //           disable: true,
  //         };
  //       }else {
  //         return {
  //           ...field,
  //           disable: false,
  //         };
  //       }
  //     });
  //     const updatedFieldKQ = dataFieldKQ.map(field => ({
  //       ...field,
  //       disable: false,
  //     }));
  //     setFieldInfo(updatedFieldTT);
  //     setFieldStates(updatedFieldKQ)



  //   }else {
  //     const updatedFieldTT = inputFieldsInit.map(field => ({
  //       ...field,
  //       disable: field.disable == false ? true :  field.disable ,
  //     }));
  //     const updatedFieldKQ = dataFieldKQ.map(field => ({
  //       ...field,
  //       disable: field.disable == false ? true :  field.disable,
  //     }));
  //     setFieldInfo(updatedFieldTT);
  //     setFieldStates(updatedFieldKQ)

  //   }
  // }, [isEditing]);
  return (
      <Spin spinning={loading}>
        <div >
          <Form form={form}>
            <Space  direction="vertical"
                    className="prescription-space">
              <div >

                <Row justify={'space-between'} align={'middle'}>
                  <Col>
                    <Typography  style={{
                      fontWeight: "700",
                      fontSize: 14,
                      fontStyle: "normal",
                      color: "#000000",
                      marginBottom: 20,
                      fontFamily:"Segoe UI",
                    }}> Khung nhập kết quả đánh giá chuyên môn</Typography>
                  </Col>
                  <Row gutter={[16, 16]}>
                    <InputFields data={fieldInfo}></InputFields>
                  </Row>
                </Row>

              </div>
              <Divider />
              <div >

                <Row justify={'space-between'} align={'middle'}>
                  <Col>
                    <Typography  style={{
                      fontWeight: "700",
                      fontSize: 14,
                      fontStyle: "normal",
                      color: "#000000",
                      marginBottom: 20,
                      fontFamily:"Segoe UI",
                    }}> Khung nhập kết quả phỏng vấn</Typography>
                  </Col>
                  <Row gutter={[16, 16]}>
                    <InputFields data={fieldStates}></InputFields>
                  </Row>
                </Row>

              </div>
              <div style={{ display: "flex", alignItems: "center" ,marginTop:"20px" }}>
                <span style={{ marginRight: "170px" , marginLeft: "8px"}}>Kết quả</span>
                <Radio.Group onChange={onChange} value={value} style={{ transform: "scale(1.1)" ,fontWeight: 400 , fontFamily:"Segoe UI"}}>
                  <Radio  value={1}>Trúng tuyển</Radio>
                  <Radio  value={2}>Không trúng tuyển</Radio>
                  <Radio  value={3}>Tiềm năng</Radio>

                </Radio.Group>
              </div>
              <Divider />
              <Row justify="end" style={{ marginTop: 12 }}>
                <Col>
                  <Space>
                    <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                    <Button htmlType="submit" type="primary" onClick={handleSubmit}>
                          Lưu lại
                        </Button>
                    {/* {isEditing ? (
                    ) : (
                        <Button
                            className="btn-sub"
                            type="primary"
                            onClick={handleEdit}
                            icon={<Icon.edit />}
                        >
                          Chỉnh sửa
                        </Button>
                    )} */}
                  </Space>{" "}
                </Col>
              </Row>
            </Space>
          </Form>
        </div>
      </Spin>
  );
};
export default Tab3;
